module.exports = __webpack_public_path__ + "static/collect-4-4b68ad0110592db389cac50baef06aed.png";